/**
 * Onboarding Context Definition
 * Types and context instance for onboarding state management
 */

import { createContext, useContext } from 'react'

export type OnboardingStep = 'workspace' | 'project' | 'task' | 'complete'

export interface OnboardingContextType {
  isOnboardingComplete: boolean
  currentStep: OnboardingStep
  workspaceId: string | null
  projectId: string | null
  workspaceName: string | null
  projectName: string | null
  taskName: string | null
  isOnboardingActive: boolean
  startOnboarding: () => void
  completeOnboarding: () => void
  skipOnboarding: () => void
  setCurrentStep: (step: OnboardingStep) => void
  setWorkspaceId: (id: string) => void
  setProjectId: (id: string) => void
  setWorkspaceName: (name: string) => void
  setProjectName: (name: string) => void
  setTaskName: (name: string) => void
  nextStep: () => void
}

export const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined)

export function useOnboarding() {
  const context = useContext(OnboardingContext)
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider')
  }
  return context
}
